import { Button, dialog } from "nq-component";
import BaseListPresenter from "../../../../base/BaseListPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { createNotification } from "../../../../createNotification";

export default class AvailableTrainingPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  // async getEmployee() {
  //   return await this.view.getcurrent();
  // }

  async findObject() {
    this.reset();
    const user = this.view.getUser();
    const employees = await this.view.getcurrent();

    const employee = employees[0];

    const fields = [
      "region",
      "office",
      "division",
      "section",
      "unit",
      "cluster",
    ];
    // If any field is missing, default to using `region`
    let result;
    let index;

    fields.forEach((field, i) => {
      if (employee[field] && employee[field] !== "") {
        result = employee[field];
        index = i;
      }
    });

    // console.log("Resulting data: ", result);

    // console.log("INDE: ", index);

    const objectOrg = [
      "selectedRegions",
      "selectedOffices",
      "selectedDivisions",
      "selectedSections",
      "selectedUnits",
      "selectedPlantilla",
    ];
    // console.warn("USER: ", user);
    let query;
    for (const role of user.roles) {
      try {
        if (role.id === "user") {
          query = {
            [objectOrg[index]]: result,
          };
        } else {
          query = {};
        }
      } catch (error) {
        console.error("ERROR: ", error);
      }
    }
    // console.log("first: ", query);
    return query;
  }
  async init() {
    // const find = await this.findObject();
    // console.log("SGLKSDJGFIO", find);
    // this.where = find;
    this.search = {};
    this.filter = {};
    this.include = ["all", "employee"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  verification(object) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Enroll Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.handleEnrollBtn(object)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  async handleEnrollBtn(object) {
    try {
      const [allTraining, myTrainingData] = await Promise.all([
        findObjectUseCase().execute("management_training"),
        findObjectUseCase().execute("enrollees"),
      ]);

      const training = allTraining.find((item) => item.id === object.id);
      if (!training) {
        console.error("Training not found");
        return;
      }

      const user = this.view.getCurrentUser();
      const employeeId = user.employee.id;

      const employees = await findObjectUseCase().execute("employees");
      const employee = employees.find((emp) => emp.id === employeeId);

      if (!employee) {
        console.error("Employee not found");
        return;
      }

      const dataToUpsert = {
        trainingID: object.id,
        training: object.training,
        targetcompetency: training.targetcompetency,
        stats: "Enroll",
        budgets: object.budgets,
        costs: object.costs,
        date: object.date,
        datefrom: object.datefrom,
        dateto: object.dateto,
        time: object.time,
        trainingMethod: object.trainingMethod,
        Firstname: employee.Firstname,
        Middlename: employee.Middlename,
        surname: employee.surname,
        email: employee.email,
        empID: employeeId,
        // assignatories
        firstSignatory: object.firstSignatory,
        firstpos: object.firstpos,
        secondSignatory: object.secondSignatory,
        secondpos: object.secondpos,
        thirdSignatory: object.thirdSignatory,
        thirdpos: object.thirdpos,
        fourthSignatory: object.fourthSignatory,
        fourthpos: object.fourthpos,
      };

      console.log("DATATOUPSERTT", object);

      const existingTraining = myTrainingData.find(
        (item) =>
          item.empID === employeeId &&
          item.trainingID === dataToUpsert.trainingID // Changed condition
      );
      // console.log("DATA:", existingTraining);

      // return;

      if (existingTraining) {
        dialog.close();
        this.view.showError("You already enrolled in this training!");
        return;
      } else {
        await upsertUseCase().execute("enrollees", dataToUpsert);
        await upsertUseCase().execute("attendees", dataToUpsert);

        //  CREATE NOTIFICATION
        const NOTIFICATION_MESSAGE =
          "An employee has enrolled in a new training program";
        const NOTIFICATION_RECEIVER = ["role:Supervisor", "role:Super Admin"];
        const NOTIFICATION_REDIRECT = "learning/training";

        createNotification(
          NOTIFICATION_MESSAGE,
          NOTIFICATION_RECEIVER,
          NOTIFICATION_REDIRECT
        );
        dialog.close();
        this.view.showSuccess("You are now enroll in this Training");
      }
    } catch (error) {
      console.error(
        "An error occurred while handling enroll button click:",
        error
      );
    }
  }
}
